import { Navbar } from "../components/site/Navbar";
import { Hero } from "../components/site/Hero";
import { About } from "../components/site/About";
import { Story } from "../components/site/Story";
import { Services } from "../components/site/Services";
import { Process } from "../components/site/Process";
import { Pricing } from "../components/site/Pricing";
import { Testimonials } from "../components/site/Testimonials";
import { Faq } from "../components/site/Faq";
import { BookingForm } from "../components/site/BookingForm";
import { Footer } from "../components/site/Footer";

export default function Home() {
  return (
    <div className="relative bg-sand min-h-screen overflow-x-hidden">
      <div className="grain-overlay" />
      <div className="relative z-10">
        <Navbar />
        <main>
          <Hero />
          <About />
          <Story />
          <Services />
          <Process />
          <Pricing />
          <Faq />
          <Testimonials />
          <BookingForm />
        </main>
        <Footer />
      </div>
    </div>
  );
}
